<template>
  <header>
  </header>
</template>

<script>
export default {
  components: {},

  data() {
    return {};
  },

  beforeCreate() {},

  computed: {},

  mixins: [],
};
</script>

<style lang="scss" scoped>
</style>
